import moment from 'moment'
import translations from './languages/locales'
import * as cookies from './cookies'
import locale2 from 'locale2'
import { createIntl, createIntlCache } from 'react-intl'

var locale = 'en'

let localeCoockie = cookies.get('languageAbbreviation');

if (localeCoockie)
{
	locale = localeCoockie;
}
else if (locale2) {
	locale = locale2.substring(0, 5)
	if (locale !== 'en-GB') {
		locale = locale2.substring(0, 2)
	}
}

if (!translations[locale]) {
	locale = 'en'
}

const cache = createIntlCache();
const intl = createIntl({ locale, messages: translations[locale] }, cache)

export const required = value => (value != null && value != undefined ? undefined : intl.formatMessage({ id: 'app.validation.required' }))

export const analogRequired = (value) => (value || value === 0 ? undefined : intl.formatMessage({ id: 'app.validation.required' }))

export const checkboxRequired = (value) => {
	if (!value) return intl.formatMessage({ id: 'app.validation.required' })

	return value.length > 0 ? undefined : intl.formatMessage({ id: 'app.validation.required' })
}

export const isValidNumber = (value) => {
	if (!value) return undefined
	return !isNaN(value) ? undefined : intl.formatMessage({ id: 'app.validation.isValidNumber' })
}

export const minMaxValueRequired = (value, allValues, props, name) => {
	if (!value) return undefined
	var fieldName = name.split('.')
	fieldName = fieldName[2]
	fieldName = fieldName.replace('_', '')
	var result = props.survey.answeredQuestions[0].questions.find((item) => item.uniqueId == fieldName)
	if (result.minimum != null) {
		if (value < result.minimum) return intl.formatMessage({ id: 'app.validation.minimumValue' }).replace('%%Minimum%%', result.minimum)
	}
	if (result.maximum != null) {
		if (value > result.maximum) return intl.formatMessage({ id: 'app.validation.maximumValue' }).replace('%%Maximum%%', result.maximum)
	}
}

export const passwordMatch = (matchName) => (value, allValues, props) => {
	return value && allValues[matchName] && value !== allValues[matchName] ? intl.formatMessage({ id: 'app.validation.passwordsMustMatch' }) : undefined
}

export const passwordStrength = (value) => {
	//special characters
	//var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')
	var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
	if (value && value.indexOf(' ') > -1) {
		return intl.formatMessage({ id: 'app.validation.spacesNotAllowed' })
	}
	return value && strongRegex.test(value)
		? undefined
		: intl.formatMessage({ id: 'app.validation.passwordStrength' })
}

export const email = (value) => {
	var strongRegex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i
	return value && strongRegex.test(value?.trim()) ? undefined : intl.formatMessage({ id: 'app.validation.invalidEmail' })
}

export const birthDate = (value) => {
	if (value) {
		var date = moment(value)
		var now = moment()
		if (date.isValid() && date.year() < 1900) {
			return intl.formatMessage({ id: 'app.validation.invalidDateTooEarly' })
		}

		if (date.isValid() && date.isAfter(now)) {
			return intl.formatMessage({ id: 'app.validation.invalidDateTooLate' }).replace('%%CurrentYear%%', now.format('YYYY/MM/DD'))
		}

		return date.isValid() ? undefined : intl.formatMessage({ id: 'app.validation.invalidDateGeneral' })
	}
}

export const date = (value) => {
	if (value) {
		var date = moment(value)
		if (date.isValid() && date.year() < 1900) {
			return intl.formatMessage({ id: 'app.validation.invalidDateTooEarly' })
		}
		if (date.isValid() && date.year() >= 2100) {
			return intl.formatMessage({ id: 'app.validation.invalidDateGeneral' })
		}
		return date.isValid() ? undefined : intl.formatMessage({ id: 'app.validation.invalidDateGeneral' })
	}
}

export const phoneNumber = (value) => {
	if (value) {
		var startsWithZero = value.startsWith('0')
		return !startsWithZero && !isNaN(value) ? undefined : intl.formatMessage({ id: 'app.validation.phoneNumber' })
	}
}

export const minDateValue = (matchName) => (value, allValues, props) => {
	return value && allValues[matchName] && new Date(value) < new Date(allValues[matchName])
		? intl.formatMessage({ id: 'app.validation.greaterOrEqualValue' }, {minValue: intl.formatDate(new Date(allValues[matchName]), {
			year:'numeric',
			month:'2-digit',
			day:'2-digit'
		})})
		: undefined
}